import {
  CatalogFilterBlueprint,
  EntityCardBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

export const dateStartedCatalogFilter = CatalogFilterBlueprint.make({
  name: 'date-started',
  params: {
    loader: () =>
      import('./DateStartedPicker').then(m => <m.DateStartedPicker />),
  },
});

// Teams ingested from GitHub carry a base64 SVG in spec.profile.picture, added
// by githubOrgUserTransformer from TEAM_METADATA. The org-plugin profile card
// only shows it at 24px, so give it a card of its own.
export const groupIconEntityCard = EntityCardBlueprint.make({
  name: 'group-icon',
  params: {
    type: 'info',
    filter: {
      $all: [{ kind: 'group' }, { 'spec.profile.picture': { $exists: true } }],
    },
    loader: () => import('./GroupIconCard').then(m => <m.GroupIconCard />),
  },
});

const JOB_TITLE_ANNOTATION = 'okta.com/job-title';
const JOB_DIVISION_ANNOTATION = 'okta.com/job-division';
const START_DATE_ANNOTATION = 'datamarx.com/start-date';

// Okta-sourced role details. The filter keeps the card off GitHub-only users
// rather than having the component render null.
export const jobInfoEntityCard = EntityCardBlueprint.make({
  name: 'job-info',
  params: {
    type: 'info',
    filter: {
      $all: [
        { kind: 'user' },
        {
          $any: [
            {
              [`metadata.annotations.${JOB_TITLE_ANNOTATION}`]: {
                $exists: true,
              },
            },
            {
              [`metadata.annotations.${JOB_DIVISION_ANNOTATION}`]: {
                $exists: true,
              },
            },
          ],
        },
      ],
    },
    loader: () => import('./JobInfoCard').then(m => <m.JobInfoCard />),
  },
});

export const joinDateEntityCard = EntityCardBlueprint.make({
  name: 'join-date',
  params: {
    type: 'info',
    filter: {
      kind: 'user',
      [`metadata.annotations.${START_DATE_ANNOTATION}`]: { $exists: true },
    },
    loader: () => import('./JoinDateCard').then(m => <m.JoinDateCard />),
  },
});
